import React from "react";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router";

export default function NavigateToHome() {
    const {i18n: {language: lng}} = useTranslation();

    return <Navigate to={`/${lng}`} replace />
}